import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

export interface BillingScreenLayoutProps {
  title: string;
  subtitle: string;
  currentCard: ReactNode;
  formCard: ReactNode;
}

/**
 * Shared layout for the three billing tabs (Plan, Paquete, Crédito).
 * Mounts the page title + subtitle and a two-column grid (stacked on
 * mobile) with the "current state" card on the left and the form card
 * on the right. Sits below the sticky `CompanyHeaderBanner` rendered
 * by `CompanyShell`.
 *
 * @param title       Heading shown above the cards (e.g., "Contratar plan").
 * @param subtitle    Short description rendered under the title.
 * @param currentCard Card showing the company's current state for this domain.
 * @param formCard    Card containing the form that posts the change.
 */
export const BillingScreenLayout = ({
  title,
  subtitle,
  currentCard,
  formCard,
}: BillingScreenLayoutProps) => (
  <Box sx={{ maxWidth: 1080, mx: 'auto', px: 3, py: 4 }}>
    <Stack spacing={0.5} sx={{ mb: 3 }}>
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {subtitle}
      </Typography>
    </Stack>
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={3}
      alignItems="stretch"
    >
      <Box flex={1} minWidth={0}>
        {currentCard}
      </Box>
      <Box flex={1} minWidth={0}>
        {formCard}
      </Box>
    </Stack>
  </Box>
);
